import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { cartItemReducer, CartItemState } from './cart-item.reducer';

export interface CartItemModuleState {
  cartItem: CartItemState;
}

export const reducers: ActionReducerMap<CartItemModuleState> = {
  cartItem: cartItemReducer,
};

export const getCartItemModuleState =
  createFeatureSelector<CartItemModuleState>('cartItems');
